import { settings } from './settings';

declare global {
    interface Window {
        SETTINGS_search: any;
        BANNERS_emergencySearchResults: any;
    }
}

// Assuming this code is running in a browser environment after including settings.ts
if (window.SETTINGS_search) {
    settings.searchApiUrl = window.SETTINGS_search.searchApiUrl || settings.searchApiUrl;
    settings.doctorSearchResults = window.SETTINGS_search.doctorSearchResults || settings.doctorSearchResults;
    settings.doctorPage = window.SETTINGS_search.doctorPage || settings.doctorPage;
    settings.dietSearchResults = window.SETTINGS_search.dietSearchResults || settings.dietSearchResults;
    settings.dietPage = window.SETTINGS_search.dietPage || settings.dietPage;
    settings.socialWorkerSearchResults = window.SETTINGS_search.socialWorkerSearchResults || settings.socialWorkerSearchResults;
    settings.socialWorkerPage = window.SETTINGS_search.socialWorkerPage || settings.socialWorkerPage;
    settings.medicalCenterSearchResults = window.SETTINGS_search.medicalCenterSearchResults || settings.medicalCenterSearchResults;
    settings.medicalCenterPage = window.SETTINGS_search.medicalCenterPage || settings.medicalCenterPage;
    settings.emergencySearchResults = window.SETTINGS_search.emergencySearchResults || settings.emergencySearchResults;
    settings.emergencyPage = window.SETTINGS_search.emergencyPage || settings.emergencyPage;
    settings.womenEmergencySearchResults = window.SETTINGS_search.womenEmergencySearchResults || settings.womenEmergencySearchResults
    settings.womenEmergencyPage = window.SETTINGS_search.womenEmergencyPage || settings.womenEmergencyPage;
    settings.pharmacySearchResults = window.SETTINGS_search.pharmacySearchResults || settings.pharmacySearchResults;
    settings.pharmacyPage = window.SETTINGS_search.pharmacyPage || settings.pharmacyPage;
    settings.opticaSearchResults = window.SETTINGS_search.opticaSearchResults || settings.opticaSearchResults;
    settings.opticaPage = window.SETTINGS_search.opticaPage || settings.opticaPage;
    settings.dentalSearchResults = window.SETTINGS_search.dentalSearchResults || settings.dentalSearchResults;
    settings.dentalPage = window.SETTINGS_search.dentalPage || settings.dentalPage;
    settings.outerServiceSearchResults = window.SETTINGS_search.outerServicesSearchResults || settings.outerServiceSearchResults;
    settings.outerServicePage = window.SETTINGS_search.outerServicesPage || settings.outerServicePage;
    settings.operationsSearchResults = window.SETTINGS_search.operationsSearchResults || settings.operationsSearchResults;
    settings.zakautServicePage = window.SETTINGS_search.zakautServicePage || settings.zakautServicePage;
    settings.zakautSubLobbyServicePage = window.SETTINGS_search.zakautSubLobbyServicePage || settings.zakautSubLobbyServicePage;
    settings.showAdvanceSearch = window.SETTINGS_search.showAdvanceSearch || settings.showAdvanceSearch;
    settings.onlineDomain = window.SETTINGS_search.onlineDomain || settings.onlineDomain;
    settings.globalSearchResults = window.SETTINGS_search.globalSearchResults || settings.globalSearchResults;
    settings.medicienceSearchResults = window.SETTINGS_search.medicienceSearchResults || settings.medicienceSearchResults;
}


export default settings;